export const TitleOrganizationTypes = [
    "organization",
    "district",
    "school",
] as const;

export const OrganizationTypesWithGrids = [
    'activity',
    'classroom',
    'collection',
    'department',
    'district',
    'group',
    'organization',
    'root',
    'section',
    'school',
    'team',
] as const;

export const OrganizationTypesWithStaffBlock = [
    'department',
    'group',
    'team',
] as const;
